import {Alert, DataStatus} from 'platform/components';

import {type ListCampaignResponseBody, useGetCampaignQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {CampaignTargeting} from '../types/CampaignTargeting';
import {areCampaignsOverlapping} from '../utils/areCampaignsOverlapping';

interface CampaignCollisionAlertProps extends RequiredTestIdProps {
  campaign: ListCampaignResponseBody;
  targeting: CampaignTargeting;
}

export function CampaignCollisionAlert(props: CampaignCollisionAlertProps) {
  const {data: campaignDetail, isLoading, isError} = useGetCampaignQuery({id: props.campaign.id});

  if (isLoading) {
    return (
      <DataStatus isLoading minHeight={2} data-testid={suffixTestId('collisionCheck', props)} />
    );
  }

  if (isError) {
    return (
      <Alert
        variant="error"
        type="inline"
        message={i18n.t('entity.salesCampaign.hints.campaignFilterCollisionCheckFailed', {
          campaignName: props.campaign.name,
        })}
        data-testid={suffixTestId('collisionCheckError', props)}
      />
    );
  }

  if (areCampaignsOverlapping(campaignDetail, props.targeting)) {
    return (
      <Alert
        variant="warning"
        type="inline"
        message={i18n.t('entity.salesCampaign.hints.campaignCollision', {
          campaignName: props.campaign.name,
        })}
        data-testid={suffixTestId('collision', props)}
      />
    );
  }

  return null;
}
